import * as z from "zod";

export const posSettingsSchema_ = z.object({
  defaultPosRestock: z.boolean().nullish(),
  chargeAmountPerReturn: z.number(),
  sendOnlyCompletionEmail: z.boolean().nullish(),
});

export const posSettingsSchema: z.ZodType<PosSettings> = posSettingsSchema_;
export interface PosSettings extends z.infer<typeof posSettingsSchema_> {}
